export default {"src":"/_next/static/image/public/images/ic_right_arrow.4f42928bc71ce3376a70f1ae3105493a.svg","height":14,"width":8};